import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { peformanceReviewListRequest } from '../../../redux/performance/peformance.action'
import moment from "moment";
import ReactStars from "react-rating-stars-component";
import Modal from 'react-bootstrap/Modal';
import { APP_CONSTANTS } from "../../../utils/AppConstants";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";

const PerformanceReviewList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { peformanceReviewListSuccess, peformanceReviewListError } = useSelector(state => state.peformance)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const TAB_LIST = [
        'ALL', `${new Date().getFullYear()}`
    ]
    const [selectedTab, setSelectedTab] = useState(TAB_LIST[0])
    const [selectedFeedback, setSelectedFeedback] = useState(null)
    const [showFeedbackModal, setShowFeedbackModal] = useState(false)
    const { state } = useLocation()

    useEffect(() => {
        if (state?.isFromMenu) {
            if (isLoggedInUserBusiness(user)) {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_REVIEW_LIST, true)
                fetchBusinessList()
            } else if (isLoggedInUserEmployee(user)) {
                fetchReviewList()
            }
        } else {
            fetchReviewList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchReviewList = (reviewYear = null) => {
        setLoading(true)
        const data = {}
        if (state?.isFromMenu) {
            if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
            if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
            data.employeeId = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            data.employeeUserType = user.data.userDetails.userType
        } else {
            data.businessId = state.businessId
            data.locationId = state.locationId
            data.employeeId = state.employeeId
            data.employeeUserType = state.userType
        }
        if (!isEmpty(reviewYear)) {
            data.reviewYear = reviewYear
        }
        dispatch(peformanceReviewListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.PERFORMANCE_REVIEW_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_REVIEW_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(peformanceReviewListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(peformanceReviewListError)) {
            setLoading(false)
        }
    }, [peformanceReviewListSuccess, peformanceReviewListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchReviewList()
        }
    }, [selectedLocation])

    const handleTabSelect = (item) => {
        setSelectedTab((prevTab) => {
            fetchReviewList(item === TAB_LIST[0] ? null : item)
            return item
        })
    }

    const handleViewFeedbackClick = (item) => {
        setSelectedFeedback(item)
        setShowFeedbackModal(true)

    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Feedbacks' />
                {state?.isFromMenu && isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === TAB_LIST[0] ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_LIST[0]) }}>{TAB_LIST[0]}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === TAB_LIST[1] ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_LIST[1]) }}>{TAB_LIST[1]}</div>
                </div>
                {!isNull(peformanceReviewListSuccess) && !isEmpty(peformanceReviewListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Review Year</th>
                                <th scope="col" className="text-center">Reviewer</th>
                                <th scope="col" className="text-center">Employee Code</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Rating</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {peformanceReviewListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.reviewYear}</td>
                                    <td className="text-center">{!isEmpty(element.reviewerDetails) ? `${element.reviewerDetails.firstName} ${element.reviewerDetails.lastName}` : 'N/A'}</td>
                                    <td className="text-center">{element.reviewerDetails?.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? !isEmpty(element.reviewerDetails?.employeeBusinessMapping[0].employeeCode) ? element.reviewerDetails?.employeeBusinessMapping[0].employeeCode : '-' : removeSpecialCharAndChangeToPascal(element.reviewerDetails.userType)}</td>
                                    <td className="text-center">{moment.utc(element.createdOn).local().format('DD/MM/YYYY')}</td>
                                    <td className="m-0 p-0">
                                        <div className="prevl-rating-container">
                                            <ReactStars
                                                count={5} // Number of stars
                                                value={element.rating} // Initial rating
                                                size={25} // Size of stars
                                                activeColor="#ffd700" // Star color
                                                isHalf={true} // Allow half-stars
                                                edit={false}
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewFeedbackClick(element) }}><div className="tr-action-btn">View Feedback</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(peformanceReviewListError) && <div className="content-error">{peformanceReviewListError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowFeedbackModal(false) }}
                show={showFeedbackModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Submit Feedback
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isEmpty(selectedFeedback) && <div className="prl-feedback-container">
                        <div className="prl-rating-container">
                            <ReactStars
                                count={5} // Number of stars
                                value={selectedFeedback.rating} // Initial rating
                                size={35} // Size of stars
                                activeColor="#ffd700" // Star color
                                isHalf={true} // Allow half-stars
                            />
                        </div>
                        <p>{selectedFeedback.feedback}</p>
                    </div>}
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PerformanceReviewList